import axios from "axios";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import BseLoginCard from "../common/BseLoginCard";

export default function Dashboard() {
  const [data, setData] = useState("");
  const [inquiry, setInquiry] = useState([]);

  const getData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/user/dashboard`,
      );
      if (res.status === 200) {
        setData(res.data.data);
      } else {
        setData([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const getInvestmentData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/investment`,
      );
      if (res.status === 200) {
        setInquiry(res.data.data.slice(0, 10));
      } else {
        setInquiry([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getInvestmentData();
    getData();
  }, []);

  return (
    <>
      {/* app-content class ensures it respects --sidebar-width set by AdminNavbar */}
      <div className="main-content">
        <div className="page-wrapper">
          <div className="content">
            <div className="row mb-4">
              <div className="col-12 d-flex align-items-center" style={{ minHeight: 50 }}>
                <BseLoginCard />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-sm-6 col-12 d-flex widget-path widget-service">
                <NavLink
                  to="/mutualfund"
                  className="w-100 text-decoration-none"
                  style={{ color: "inherit" }}
                >
                  <div className="card cursor-pointer">
                    <div className="card-body">
                      <div className="home-user">
                        <div className="home-userhead">
                          <div className="home-usercount">
                            <span>
                              <img src="assets/img/icons/user.svg" alt="img" />
                            </span>
                            <h6>Mutual Fund Customers</h6>
                          </div>
                        </div>

                        <div className="home-usercontent">
                          <div className="home-usercontents">
                            <div className="home-usercontentcount">
                              <img
                                src="assets/img/icons/arrow-up.svg"
                                alt="img"
                                className="me-2"
                              />
                              <span className="counters">
                                {data.mutual_fund_users}
                              </span>
                            </div>
                          </div>

                          <div className="homegraph">
                            <img src="assets/img/graph/graph1.png" alt="img" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </NavLink>
              </div>
              <div className="col-lg-4 col-sm-6 col-12 d-flex widget-path widget-service">
                <NavLink
                  to="/loan-application"
                  className="w-100 text-decoration-none"
                  style={{ color: "inherit" }}
                >
                  <div className="card cursor-pointer">
                    <div className="card-body">
                      <div className="home-user home-provider">
                        <div className="home-userhead">
                          <div className="home-usercount">
                            <span>
                              <img
                                src="assets/img/icons/user-circle.svg"
                                alt="img"
                              />
                            </span>
                            <h6>Loan Segment Clients</h6>
                          </div>
                        </div>

                        <div className="home-usercontent">
                          <div className="home-usercontents">
                            <div className="home-usercontentcount">
                              <img
                                src="assets/img/icons/arrow-up.svg"
                                alt="img"
                                className="me-2"
                              />
                              <span className="counters">
                                {data.loan_users}
                              </span>
                            </div>
                          </div>

                          <div className="homegraph">
                            <img src="assets/img/graph/graph2.png" alt="img" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </NavLink>
              </div>
              {/* <div className="col-lg-3 col-sm-6 col-12 d-flex widget-path widget-service">
                <div className="card">
                  <div className="card-body">
                    <div className="home-user home-service">
                      <div className="home-userhead">
                        <div className="home-usercount">
                          <span>
                            <img src="assets/img/icons/service.svg" alt="img" />
                          </span>
                          <h6>Research Analyst subscribers</h6>
                        </div>
                      </div>
                      <div className="home-usercontent">
                        <div className="home-usercontents">
                          <div className="home-usercontentcount">
                            <img
                              src="assets/img/icons/arrow-up.svg"
                              alt="img"
                              className="me-2"
                            />
                            <span className="counters" data-count="18">
                              5
                            </span>
                          </div>
                        </div>
                        <div className="homegraph">
                          <img src="assets/img/graph/graph3.png" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="col-lg-4 col-sm-6 col-12 d-flex widget-path widget-service">
                <NavLink
                  to="/user"
                  className="w-100 text-decoration-none"
                  style={{ color: "inherit" }}
                >
                  <div className="card cursor-pointer">
                    <div className="card-body">
                      <div className="home-user home-subscription">
                        <div className="home-userhead">
                          <div className="home-usercount">
                            <span>
                              <img src="assets/img/icons/money.svg" alt="img" />
                            </span>
                            <h6>Users</h6>
                          </div>
                        </div>

                        <div className="home-usercontent">
                          <div className="home-usercontents">
                            <div className="home-usercontentcount">
                              <img
                                src="assets/img/icons/arrow-up.svg"
                                alt="img"
                                className="me-2"
                              />
                              <span className="counters">
                                {data.total_users}
                              </span>
                            </div>
                          </div>

                          <div className="homegraph">
                            <img src="assets/img/graph/graph4.png" alt="img" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </NavLink>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 widget-path">
                <div className="card mb-0">
                  <div className="card-body">
                    <div className="home-user">
                      <div className="home-head-user home-graph-header">
                        <h2>Investment Enquiry</h2>
                      </div>
                      <div className="table-responsive datatable-nofooter">
                        <div
                          id="DataTables_Table_2_wrapper"
                          className="dataTables_wrapper dt-bootstrap4 no-footer"
                        >
                          <table
                            className="table datatable dataTable no-footer"
                            id="DataTables_Table_2"
                            role="grid"
                            aria-describedby="DataTables_Table_2_info"
                          >
                            <thead>
                              <tr role="row">
                                <th>Sr No</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Name</th>
                                <th>Service inquired</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {inquiry.map((dataa, i) => (
                                <tr key={i} className="odd">
                                  <td className="sorting_1">1</td>
                                  <td>
                                    {new Date(
                                      dataa.created_at,
                                    ).toLocaleDateString()}
                                  </td>
                                  <td>
                                    {new Date(
                                      dataa.created_at,
                                    ).toLocaleTimeString()}
                                  </td>
                                  <td>{dataa.name}</td>
                                  <td>
                                    <h6 className="badge-pending">Pending</h6>
                                  </td>
                                  <td>
                                    {dataa.status === 0 ? (
                                      <h6 className="badge-pending">Pending</h6>
                                    ) : (
                                      <h6 className="badge-active">
                                        Completed
                                      </h6>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* .app-content */}
    </>
  );
}
